import { semantic_colors, text_styles, colors } from '@croquiscom/pds';
import { Theme } from '@emotion/react';

export const theme: Theme = {
  palette: { ...semantic_colors, colors },
  typography: text_styles,
};
